<main>
  <myp-s1-status-header></myp-s1-status-header>
  <!-- Page title - visually hidden but accessible -->
  <div class="sr-only">
    <fui-heading [text]="(user.active_subscription ? env.studioOnePlusBrandName : 'PreSonus') + ': Home'" [level]="1" fontSize="f11"></fui-heading>
  </div>
  <!-- START | section: your profile -->
  <div class="secondary-content-bg m-b-20">
    <div class="fullwidth-layout-container">
      @if (needsMoreData && userService.dataWeNeed && userService.dataWeNeed.length) {
        <section class="home-section w-full" aria-label="your profile">
          <div class="p-t-30 p-b-50 data-we-need">
            <div class="section-header is-grid">
              <fui-heading [text]="'sphere.your_profile' | translate" [level]="2" fontSize="f8"></fui-heading>
              <a class="section-header-link" [routerLink]="['../account/general']">{{ "profile.edit_profile" | translate }}</a>
            </div>
            <div class="d-flex">
              <div>
                <div class="data-we-need-profile-photo" [ngStyle]="{ 'background-image': user.photoURL ? 'url(' + user.photoURL + ')' : 'url(./assets/images/default_avatar.jpg)' }">
                  <round-progress
                    [current]="profileProgress.percentage"
                    [max]="100"
                    [color]="appService.activeTheme == 'dark' ? '#d52b1e' : '#121212'"
                    [background]="appService.activeTheme == 'dark' ? '#333' : '#eaeaea'"
                    [radius]="55"
                    [stroke]="5"
                    [semicircle]="false"
                    [rounded]="true"
                    [clockwise]="true"
                    [responsive]="false"
                    [duration]="250"
                    [animation]="'easeInOutQuart'"
                    [animationDelay]="0"
                  ></round-progress>
                  <a [routerLink]="['../account/general']" class="btn btn-sm" [class.btn-primary]="appService.activeTheme == 'dark'" [class.btn-secondary]="appService.activeTheme == 'light'">
                    {{ profileProgress.percentage }}% {{ "home.complete" | translate }}
                  </a>
                </div>
              </div>
              <div class="m-l-50">
                <fui-heading [text]="user.firstName + ' ' + user.lastName" [level]="4" fontSize="f5"></fui-heading>
                <div class="t-14 m-b-10 m-t-10">{{ "account.member_since" | translate }} {{ user.createdTime | date: "YYYY" }}</div>
                <div class="t-12 m-b-20">{{ "account.completing_your_profile" | translate }}</div>
                <div class="need-pills">
                  <ul class="more-info-list">
                    @for (field of userService.dataWeNeed; track field) {
                      <li [class.done]="field.key == 'skills' ? (user.skills?.length ?? 0) > 0 : user[field.key]">
                        <a [routerLink]="['../account/general']">
                          <fa-icon [icon]="field.key == 'skills' ? ((user.skills?.length ?? 0) > 0 ? 'check' : 'times') : user[field.key] ? 'check' : 'times'"></fa-icon>
                          <span class="sr-only">
                            {{
                              field.key == "skills"
                                ? (user.skills?.length ?? 0) > 0
                                  ? ("home.complete" | translate) + " "
                                  : ("home.missing" | translate) + " "
                                : user[field.key]
                                  ? ("home.complete" | translate) + " "
                                  : ("home.missing" | translate) + " "
                            }}
                          </span>
                          {{ field.translation_key | translate }}
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
            <button class="btn btn-primary btn-sm mobile-data-we-need-button" [routerLink]="['../account/general']">{{ "account.complete_profile" | translate }}</button>
          </div>
        </section>
      }
    </div>
  </div>
  <div>
    <div basepage="primary" class="fullwidth-layout-container">
      <div class="row">
        <div class="col-12">
          <!-- The Discord gift is deliberately OUTSIDE the subscriber gate below. Subscribers see
               no paid upgrade offers, but they do have something to claim — a year of the
               subscription they already pay for — and hiding the section from them hid it from
               exactly the people it now applies to. -->
          @if (discordGift.canClaimGift || (!user.active_subscription && (activeCoupon || subscriptionPromotion || otherPromotions?.length))) {
            <section class="home-section w-full m-b-50" aria-label="upgrades">
              <div class="section-header is-grid m-b-20">
                <fui-heading [text]="'home.upgrades_special_offers' | translate" [level]="2" fontSize="f8"></fui-heading>
              </div>
              <!-- Leads the section: a free copy beats anything priced below it, and the paid
                   Fender Studio Pro offers are filtered out when this shows. -->
              <fui-discord-free-fsp-offer></fui-discord-free-fsp-offer>
              @if (!user.active_subscription) {
                @if (activeCoupon) {
                  <div class="align-items-center m-b-50 offer-container">
                    <img
                      [src]="contentService.logos[appService.app][appService.activeTheme].subscriptionBoxAnnual"
                      class="m-r-20 offer-image"
                      style="max-width: 300px; display: inline-block"
                      width="100%"
                      alt=""
                    />
                    <div class="offer-text">
                      <fui-heading [text]="activeCoupon.display_message" level="2" fontSize="f6"></fui-heading>
                      Own it forever — get a Fender Studio Pro perpetual license with a one-time purchase and keep all the latest features, no subscription required.
                      <br />
                      <br />
                      <button type="button" class="btn btn-primary" (click)="buyPerpetualLicense()">
                        @if (perpetualDiscountedPrice) {
                          {{ "product_detail.buy_now" | translate }}
                          <span class="brandfont-bold" [ngStyle]="{ 'text-decoration': 'line-through' }">{{ perpetualPrice | currency: "USD" }}</span>
                          <span class="brandfont-black">&nbsp;&nbsp;{{ perpetualDiscountedPrice | currency: "USD" }}</span>
                        }
                      </button>
                    </div>
                  </div>
                }
                @if (subscriptionPromotion) {
                  <div class="align-items-center m-b-50 offer-container">
                    <img
                      [src]="contentService.logos[appService.app][appService.activeTheme].subscriptionBoxAnnual"
                      class="m-r-20 offer-image"
                      style="max-width: 300px; display: inline-block"
                      width="100%"
                      alt=""
                    />
                    <div class="offer-text">
                      <fui-heading
                        [text]="
                          (subscriptionPromotion.coupon?.percent_off
                            ? subscriptionPromotion.coupon.percent_off + '% off '
                            : subscriptionPromotion.coupon?.amount_off
                              ? (subscriptionPromotion.coupon.amount_off / 100 | currency: (subscriptionPromotion.coupon.currency || 'usd').toUpperCase()) + ' off '
                              : '') +
                          (subscriptionPromotion.offer_product?.product?.id == env.product_ids.sphere_monthly ? 'Fender Studio Pro+ Monthly' : 'Fender Studio Pro+ Annual') +
                          '!'
                        "
                        level="2"
                        fontSize="f6"
                      ></fui-heading>
                      Because you own {{ subscriptionPromotion.parent_product?.product?.title || "a qualifying product" }}, you're eligible for a discount on
                      {{ subscriptionPromotion.offer_product?.product?.id == env.product_ids.sphere_monthly ? "Fender Studio Pro+ Monthly" : "Fender Studio Pro+ Annual" }}!
                      <br />
                      <br />
                      <button type="button" class="btn btn-primary" (click)="redeemPromotion(subscriptionPromotion)">{{ "onboarding.join_now" | translate }}</button>
                    </div>
                  </div>
                }
                @for (promo of otherPromotions; track promo.id) {
                  <div class="align-items-center m-b-50 offer-container">
                    @if (promo.offer_product?.product?.imageUrl) {
                      <img [src]="promo.offer_product.product.imageUrl" class="m-r-20 offer-image" style="max-width: 300px; display: inline-block" width="100%" alt="" />
                    }
                    <div class="offer-text">
                      <fui-heading
                        [text]="
                          (promo.coupon?.percent_off
                            ? promo.coupon.percent_off + '% off '
                            : promo.coupon?.amount_off
                              ? (promo.coupon.amount_off / 100 | currency: (promo.coupon.currency || 'usd').toUpperCase()) + ' off '
                              : 'Discount on ') +
                          (promo.offer_product?.product?.title || 'a product') +
                          '!'
                        "
                        level="2"
                        fontSize="f6"
                      ></fui-heading>
                      Because you own {{ promo.parent_product?.product?.title || "a qualifying product" }}, you're eligible for a discount on
                      {{ promo.offer_product?.product?.title || "this product" }}!
                      <br />
                      <br />
                      <button type="button" class="btn btn-primary" (click)="redeemPromotion(promo)">{{ "onboarding.join_now" | translate }}</button>
                    </div>
                  </div>
                }
              }
            </section>
          }

          <fui-upcoming-live-event></fui-upcoming-live-event>
          <myp-new-product-added></myp-new-product-added>

          <!-- START | section: your products -->
          <section class="home-section w-full m-b-50" aria-label="products">
            @if (recentProducts && recentProducts.length) {
              <div class="section-header is-grid m-b-20">
                <fui-heading [text]="'newdash.newest_products' | translate" [level]="2" fontSize="f8"></fui-heading>
                @if (recentProducts && recentProducts.length) {
                  <a class="section-header-link" [routerLink]="['../products']">{{ "sphere.view_all" | translate }}</a>
                }
              </div>
            }
            @if (productsLoading) {
              @if (!isSmallViewport) {
                <div class="grid-container even-rows-5 pad-10">
                  <myp-skeleton-loader height="353px" type="product-tile"></myp-skeleton-loader>
                  <myp-skeleton-loader height="353px" type="product-tile"></myp-skeleton-loader>
                  <myp-skeleton-loader height="353px" type="product-tile"></myp-skeleton-loader>
                  <myp-skeleton-loader height="353px" type="product-tile"></myp-skeleton-loader>
                  <myp-skeleton-loader height="353px" type="product-tile"></myp-skeleton-loader>
                </div>
              } @else {
                <myp-skeleton-loader type="list-item" [number]="5" extraContainerClass="m-b-10"></myp-skeleton-loader>
              }
            }

            @if (!productsLoading) {
              @if (recentProducts && !recentProducts.length) {
                <div class="d-flex align-items-center m-y-20">
                  <div class="fui-header-hero">
                    <div>
                      <div class="d-flex justify-content-center m-b-20">
                        <myp-svg id="fender-logo" class="svg-white" width="100" height="50" style="margin-right: 20px" />
                        <myp-svg id="presonus-logo" class="svg-white" width="130" height="50" />
                      </div>
                      <div class="d-flex justify-content-center m-b-30 flex-wrap">
                        <myp-svg id="jackson-logo" class="svg-white m-x-10" width="90" height="45" />
                        <myp-svg id="charvel-logo" class="svg-white m-x-10" width="90" height="45" />
                        <myp-svg id="evh-logo" class="svg-white m-x-10" width="90" height="45" />
                        <myp-svg id="gretsch-logo" class="svg-white m-x-10" width="90" height="45" />
                      </div>
                      <fui-heading [text]="'my_gear.register_your_gear' | translate" color="white" textAlign="center" [level]="2" fontSize="f9"></fui-heading>
                      <span class="text-center">{{ "my_gear.register_your_gear_description" | translate }}</span>
                      <div>
                        <button class="btn btn-secondary white m-t-30" (click)="registerProduct()">{{ "my_gear.register_your_gear_button" | translate }}</button>
                        <button class="btn btn-blank m-t-30 c-white" (click)="appService.goToFenderShop()">
                          {{ "my_gear.register_your_gear_button_fender" | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (!isSmallViewport) {
                <ul class="grid-container even-rows-5 pad-4">
                  @if (recentProducts?.length) {
                    <li class="mr-0">
                      <myp-product-tile (registerProductClicked)="registerProduct()" [registerProductTile]="true" class="h-full register-product-tile"></myp-product-tile>
                    </li>
                  }
                  @if (productService.elligleToRedeemStudioOneSeven) {
                    <li class="mr-0">
                      <myp-product-tile (redeems17Clicked)="redeemS17()" [redeemS17Tile]="true" class="h-full"></myp-product-tile>
                    </li>
                  }
                  @if (recentProducts && recentProducts.length) {
                    @for (prod of recentProducts; track prod.id) {
                      <li class="mr-0">
                        <myp-product-tile (tileClicked)="tileClick(prod)" [product]="prod" class="h-full pt-0"></myp-product-tile>
                      </li>
                    }
                  }
                </ul>
              } @else {
                <div>
                  @if (recentProducts?.length) {
                    <div class="list-register-product m-b-10" role="group" [attr.aria-label]="'newdash.register_product' | translate" (click)="registerProduct()">
                      <fa-icon icon="plus-circle" class="register-product-icon"></fa-icon>
                      <div class="register-product-content text-left">
                        {{ "newdash.prod_page_slug" | translate }}
                      </div>
                      <button type="button" class="btn btn-secondary register-product-btn text-nowrap" role="link" tabindex="0" #register>{{ "newdash.register_product" | translate }}</button>
                    </div>
                  }
                  @if (productService.elligleToRedeemStudioOneSeven) {
                    <myp-product-tile (redeems17Clicked)="redeemS17()" [redeemS17Tile]="true" class="m-b-10"></myp-product-tile>
                  }
                  @for (prod of recentProducts; track prod.id) {
                    <myp-list-item
                      [title]="prod.title"
                      [photo]="prod.imageUrl"
                      [showBackground]="true"
                      [showUnreadBadge]="userService.userMetadataLoaded && (!userService.userMetadata.products_seen || !userService.userMetadata.products_seen[prod.id])"
                      [metadata]="[
                        {
                          title: ('products.registered' | translate),
                          value: prod.aquired || prod.releaseDate | date,
                        },
                      ]"
                      marginBottom="10px"
                      (itemClicked)="tileClick($event)"
                      [imageRound]="false"
                      [item]="prod"
                    >
                      <div class="button-content">
                        @if (prod && prod.categoryId == "software") {
                          <button
                            class="m-r-10 fa-button"
                            (keyup.enter)="downloadInstaller(prod); $event.stopPropagation()"
                            (click)="downloadInstaller(prod); $event.stopPropagation()"
                            [ngbTooltip]="'products.download_installer' | translate"
                            placement="top"
                            tooltipClass="nowrap"
                          >
                            <fa-icon [attr.aria-label]="'sphere.download' | translate" icon="download"></fa-icon>
                          </button>
                        }
                        @if (prod && prod.featuredSample) {
                          <button
                            class="m-r-10 fa-button"
                            (keyup.enter)="playSample(prod, $event); $event.stopPropagation()"
                            (click)="playSample(prod, $event); $event.stopPropagation()"
                            [ngbTooltip]="'products.play_sample' | translate"
                            placement="top"
                            tooltipClass="nowrap"
                          >
                            <fa-icon [attr.aria-label]="'products.play_sample' | translate" icon="play-circle"></fa-icon>
                          </button>
                        }
                      </div>
                    </myp-list-item>
                  }
                </div>
              }
            }
          </section>
          <!-- END | section: your products -->

          <!-- START | section: latest videos -->
          <section class="home-section w-full m-b-50" aria-label="latest videos">
            <div class="section-header is-grid m-b-20">
              <fui-heading [text]="'sphere.latest_videos' | translate" [level]="2" fontSize="f8"></fui-heading>
              <a class="section-header-link" [routerLink]="['../learn/videos/all']">{{ "sphere.view_all" | translate }}</a>
            </div>

            @if (videosLoading) {
              <div class="grid-container even-rows pad-10">
                <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
                <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
                <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
                <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
              </div>
            }
            <ul class="list-inline grid-container wider even-rows pad-10">
              @for (video of videos; track video) {
                <li class="list-inline-item">
                  <myp-video-grid-item [video]="video"></myp-video-grid-item>
                </li>
              }
            </ul>
          </section>
          <!-- END | section: latest videos -->

          <!-- START | section: latest from your communities.
               Self-hiding: the component renders nothing when the reader follows no
               communities or none of them have posted recently. -->
          <myp-community-feed [limit]="8"></myp-community-feed>
          <!-- END | section: latest from your communities -->

          <!-- START | section: upcoming events -->
          @if (newEvents.length || newEventsLoading) {
            <section class="home-section m-b-50 w-full" aria-label="upcoming events">
              <div class="section-header is-grid">
                <fui-heading [text]="'sphere.special_events' | translate" extraClasses="m-b-20" [level]="2" fontSize="f8"></fui-heading>
                <a class="section-header-link" [routerLink]="['../events']">{{ "sphere.view_all" | translate }}</a>
              </div>
              @if (newEventsLoading) {
                <myp-inline-loader [loading]="newEventsLoading" height="100px" spinnerName="eventsLoader"></myp-inline-loader>
              }
              @for (event of newEvents; track event.id) {
                <myp-list-item
                  [title]="event.title"
                  [subData]="[event._formattedDate]"
                  [showImage]="!!event.image_url"
                  [photo]="event.image_url"
                  [imageRound]="false"
                  [largeImage]="true"
                  marginBottom="10px"
                  [description]="event.description"
                  (itemClicked)="goToEvent(event)"
                ></myp-list-item>
              }
            </section>
          }
          <!-- END | section: upcoming events -->

          <!-- START | section: redeemable bundled products -->
          @if (productService.redeemableBundledProducts?.length) {
            <div class="home-section w-full m-b-50">
              <div class="section-header is-grid">
                <fui-heading [text]="'home.products_you_can_redeem' | translate" [level]="2" fontSize="f8"></fui-heading>
              </div>
              <div class="m-b-20">{{ "home.redeem_products_message" | translate }}</div>
              @if (!isSmallViewport) {
                <ul class="grid-container even-rows-5 pad-4">
                  @for (prod of productService.redeemableBundledProducts; track prod.id) {
                    <li class="mr-0">
                      <myp-product-tile (tileClicked)="tileClick(prod)" [product]="prod" class="h-full pt-0"></myp-product-tile>
                    </li>
                  }
                </ul>
              } @else {
                <div>
                  @for (prod of productService.redeemableBundledProducts; track prod.id) {
                    <myp-list-item
                      [title]="prod.title"
                      [photo]="prod.imageUrl"
                      [showBackground]="true"
                      [metadata]="[
                        {
                          title: ('products.registered' | translate),
                          value: prod.aquired || prod.releaseDate | date,
                        },
                      ]"
                      marginBottom="10px"
                      (itemClicked)="tileClick($event)"
                      [imageRound]="false"
                      [item]="prod"
                    ></myp-list-item>
                  }
                </div>
              }
            </div>
          }
          <!-- END | section: redeemable bundled products -->

          <!-- START | section: upgrades -->
          @if (!user.active_subscription) {
            <section class="home-section w-full m-b-50" aria-label="upgrades">
              <!-- Suppress the heading when the promotions section above already rendered its own
                   "Upgrades and Special Offers" heading — otherwise the page shows the title
                   twice (and Playwright's strict-mode locator fails). Both sections share the
                   `!user.active_subscription` root condition, so the top section rendering
                   implies we're here too. -->
              @if (!activeCoupon && !subscriptionPromotion && !otherPromotions?.length) {
                <div class="section-header is-grid m-b-20">
                  <fui-heading [text]="'home.upgrades_special_offers' | translate" [level]="2" fontSize="f8"></fui-heading>
                </div>
              }

              @if (!subscriptionPromotion && (!otherPromotions || !otherPromotions.length)) {
                <div class="align-items-center m-b-50 offer-container">
                  <img
                    [src]="contentService.logos[appService.app][appService.activeTheme].subscriptionBoxAnnual"
                    class="m-r-20 offer-image"
                    style="max-width: 300px; display: inline-block"
                    width="100%"
                    alt=""
                  />
                  <div class="offer-text">
                    <fui-heading [text]="'home.subscribe_fender_studio_pro_plus' | translate" level="2" fontSize="f6"></fui-heading>
                    {{ "home.fender_studio_pro_description" | translate }}
                    <br />
                    <br />
                    <button type="button" class="btn btn-primary" (click)="upgrade()">{{ "onboarding.join_now" | translate }}</button>
                  </div>
                </div>
              }
              <div class="align-items-center m-b-50 m-t-30 offer-container">
                <img
                  src="https://www.fender.com/cdn-cgi/image/format=auto/https://images.ctfassets.net/mdpgzc1lmx9t/6dm00mq0ASKUzDJDdqaxEV/042e46e027dc46b6270eeebc6e325536/Fender_Studio_Edit_Tracks-v3.webp"
                  class="m-r-20 offer-image"
                  style="max-width: 300px; display: inline-block"
                  width="100%"
                  alt=""
                />
                <div class="offer-text">
                  <fui-heading [text]="'home.fender_studio_mobile_app_free' | translate" level="2" fontSize="f6"></fui-heading>
                  {{ "home.fender_studio_pro_description" | translate }}
                  <br />
                  <br />
                  <img
                    src="https://images.ctfassets.net/r1mvpfown1y6/I6wP6wbRgu6nl2WbKiTUr/0ebfd271a4fba0070940955c767f23a0/Download_on_the_App_Store_Badge.svg"
                    style="width: 150px; margin-right: 10px; display: inline-block"
                    alt=""
                  />
                  <img
                    src="https://images.ctfassets.net/r1mvpfown1y6/cGKmfaCPBarxVgSTlprue/40bcb9596a2801c09c62d19d1a915c04/google-play-badge__2_.png"
                    style="width: 150px; display: inline-block"
                    alt=""
                  />
                </div>
              </div>
            </section>
          }
          <!-- END | section: upgrades -->
        </div>
      </div>
    </div>
  </div>

  <div class="fullwidth-layout-container">
    <div class="row">
      <div class="col-12">
        @if (showStudioProDemoCta && !user.active_subscription && user.subscription?.status != "expired" && !user.subscription?.cancel_date) {
          <div class="home-section w-full m-b-50">
            @if (!productsLoading && shouldSeeS1Demo) {
              <div class="align-items-start m-b-50 offer-container">
                <img src="./assets/images/fs-demo-landscape.png" class="m-r-20 offer-image" style="max-width: 300px; display: inline-block" width="100%" alt="" />
                <div class="offer-text">
                  <fui-heading [text]="'profile.demo.try_s14_demo' | translate" [level]="3" fontSize="f7"></fui-heading>
                  <p>{{ "profile.demo.download_demo_description" | translate }}</p>
                  <p>{{ "profile.demo.demo_features_description" | translate }}</p>
                  <p>{{ "profile.demo.start_trial_cta" | translate }}</p>
                  <br />
                  <button class="btn btn-primary" (click)="getFreeProduct('studioapp8.demo')">{{ (gettingS1Demo ? "general.loading_dots" : "profile.demo.get_the_demo") | translate }}</button>
                </div>
              </div>
            }
          </div>
        }

        @if (
          (!user.active_subscription && user.subscription && user.subscription.status == "expired" && !user.subscription.cancel_date) ||
          (!user.active_subscription && user.subscription && user.subscription.status == "expired" && user.subscription.cancel_date)
        ) {
          <div class="home-section w-full m-b-50">
            @if (!user.active_subscription && user.subscription && user.subscription.status == "expired" && !user.subscription.cancel_date) {
              <div class="m-b-20">
                <fui-heading [text]="'sphere.account.reactivate_subscription' | translate" [level]="3" fontSize="f7" extraClasses="section-header is-grid m-b-20"></fui-heading>
                <div class="align-items-center m-b-50 offer-container">
                  <img src="./assets/images/presonus-sphere-bundle.png" class="m-r-20 offer-image" style="max-width: 300px; display: inline-block" width="100%" alt="" />
                  <div class="offer-text">
                    <span>{{ "newdash.reactivate_membership_msg" | translate }}</span>
                    <br />
                    <br />
                    <a class="btn btn-primary" (click)="upgrade()">{{ "sphere.account.reactivate_subscription" | translate }}</a>
                  </div>
                </div>
              </div>
            }
            @if (!user.active_subscription && user.subscription && user.subscription.status == "expired" && user.subscription.cancel_date) {
              <div class="m-b-20">
                <fui-heading [text]="'sphere.account.reactivate_subscription' | translate" [level]="3" fontSize="f7" extraClasses="section-header is-grid m-b-20"></fui-heading>
                <span>
                  {{ "newdash.miss_you_msg" | translate }}
                </span>
                <br />
                <br />
                <a class="btn btn-primary" [routerLink]="['../account/plan']">{{ "sphere.account.reactivate_subscription" | translate }}</a>
              </div>
            }
          </div>
        }

        <div class="home-section m-b-20 w-full">
          <myp-collaboration-invite-notice></myp-collaboration-invite-notice>
        </div>
      </div>
    </div>
  </div>
</main>

<footer>
  <div class="secondary-content-bg">
    <div class="fullwidth-layout-container">
      <div class="p-t-50">
        <div class="container">
          <div class="row row-cols-1 row-cols-md-3 row-cols-xl-5">
            <div class="col text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/fender-studio.png" alt="Fender Studio App Icon" />
              <br />
              <span class="fui-heading-font t-16">{{ "home.fender_studio_tagline" | translate }}</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.fender_studio_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/pages/fender-studio-app" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
            <div class="col text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/play-app-icon.png" alt="Fender Play App Icon" />
              <br />
              <span class="fui-heading-font t-16">{{ "home.fender_play" | translate }}</span>
              <br />
              <div class="fui-app-callout-desc">{{ "education.fender_play_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/play" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
            <div class="col text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/tune-app-icon.png" alt="Fender Tune App Icon" />
              <br />
              <span class="fui-heading-font t-16">{{ "home.fender_tune" | translate }}</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.tune_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/online-guitar-tuner/" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
            <div class="col text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/tone-app-icon.png" alt="Fender Tone App Icon" />
              <br />
              <span class="fui-heading-font t-16">{{ "home.fender_tone" | translate }}</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.tone_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/pages/tone-app-amp-control" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
            <div class="col text-center p-t-20 fui-app-callout">
              <img src="./assets/icons/notion-app-icon.png" alt="Fender Notion App Icon" />
              <br />
              <span class="fui-heading-font t-16">{{ "home.fender_notion" | translate }}</span>
              <br />
              <div class="fui-app-callout-desc">{{ "home.notion_app_description" | translate }}</div>
              <br />
              <br />
              <a class="btn btn-blank" href="https://www.fender.com/pages/fender-notion" target="_blank">{{ "general.learn_more" | translate }}</a>
            </div>
          </div>
        </div>
        <div class="m-t-100 p-b-50">
          <fui-footer></fui-footer>
        </div>
      </div>
    </div>
  </div>
</footer>

<ngx-spinner size="large" color="#fff" bdColor="rgba(51,51,51,0.0)" type="line-scale-pulse-out"></ngx-spinner>
